import { configureStore } from '@reduxjs/toolkit';
import OrganizationListReducer from './slices/OrganizationSlice'
import UserReducer from './slices/UserSlice'
import NotesReducer from './slices/NotesSlice'
import GlobalSearchReducer from './slices/GlobalSearchSlice'

export const store = configureStore({
  reducer: {
    OrganizationListStore: OrganizationListReducer,
    UserStore: UserReducer,
    NotesStore: NotesReducer,
    GlobalSearchStore: GlobalSearchReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
